export const summaryPageTopMenu = {
	intro: { id: 'intro', text: 'Intro', path: '#intro', icon: 'Vrpano', subMenu: null },
	bootstrap: {
		id: 'bootstrap',
		text: 'Bootstrap Components',
		path: '#bootstrap',
		icon: 'BootstrapFill',
		subMenu: null,
	},
	storybook: {
		id: 'storybook',
		text: 'Storybook',
		path: '#storybook',
		icon: 'CustomStorybook',
		subMenu: null,
	},
	formik: {
		id: 'formik',
		text: 'Formik',
		path: '#formik',
		icon: 'CheckBox',
		subMenu: null,
	},
	apex: {
		id: 'apex',
		text: 'Apex Charts',
		path: '#apex',
		icon: 'AreaChart',
		subMenu: null,
	},
};

export const dashboardPagesMenu = {
	analytics: {
		id: 'analytics',
		text: 'Analytics Dashboard',
		path: 'analytics-dashboard',
		icon: 'BarChart',
		notification: false,
		subMenu: null,
	},
	manageUsers: {
		id: 'manageUsers',
		text: 'Manage Users',
		path: 'usermanager/list',
		icon: 'People',
		notification: false,
		subMenu: null,
	},
	manageArticles: {
		id: 'manageArticles',
		text: 'News Articles',
		path: 'artclesmanager/list',
		icon: 'DynamicFeed',
		notification: false,
		subMenu: null,
	},
	createNewArticle: {
		id: 'createNewArticle',
		text: 'Create Article',
		path: 'createNewArticle',
		icon: 'Add',
		notification: false,
		subMenu: null,
	},
	campaignManagement: {
		id: 'campaignManagement',
		text: 'Campaign Management',
		path: 'campaign-management',
		icon: 'AdsClick',
		notification: false,
		subMenu: null,
	},
	pushNotifications: {
		id: 'pushNotifications',
		text: 'Push Notifications',
		path: 'push-notifications',
		icon: 'NotificationsActive',
		notification: false,
		subMenu: null,
	},
	postData: {
		id: 'postData',
		text: 'Post Data',
		path: 'post-data',
		icon: 'ViewList',
		notification: false,
		subMenu: null,
	},
	appVersionManagement: {
		id: 'appVersionManagement',
		text: 'App Version Gate',
		path: 'app-version-management',
		icon: 'Smartphone',
		notification: false,
		subMenu: null,
	},
	webSeries: {
		id: 'webSeries',
		text: 'Web Series',
		path: '#',
		icon: 'PlaylistPlay',
		notification: false,
		subMenu: {
			allSeries: {
				id: 'allSeries',
				text: 'All Series',
				path: 'admin/web-series',
				icon: 'VideoLibrary',
			},
			createSeries: {
				id: 'createSeries',
				text: 'Create Series',
				path: 'admin/web-series/create',
				icon: 'VideoCall',
			},
			webSeriesArticles: {
				id: 'webSeriesArticles',
				text: 'Articles',
				path: 'admin/web-series/articles',
				icon: 'Article',
			},
			webSeriesSections: {
				id: 'webSeriesSections',
				text: 'Home Sections',
				path: 'admin/web-series-sections',
				icon: 'ViewCarousel',
			},
		},
	},
	categoryManagement: {
		id: 'categoryManagement',
		text: 'Category Management',
		path: '#',
		icon: 'Category',
		notification: false,
		subMenu: {
			allCategories: {
				id: 'allCategories',
				text: 'All Categories',
				path: 'admin/categories',
				icon: 'Label',
			},
		},
	},
	homeSectionManagement: {
		id: 'homeSectionManagement',
		text: 'Home Sections',
		path: 'admin/home-sections',
		icon: 'Dashboard',
		notification: false,
		subMenu: null,
	},
	workflowManagement: {
		id: 'workflowManagement',
		text: 'Article Workflow',
		path: '#',
		icon: 'CheckCircle',
		notification: false,
		subMenu: {
			authorWorkflow: {
				id: 'authorWorkflow',
				text: 'Author Dashboard',
				path: 'workflow/author',
				icon: 'PersonOutline',
			},
			editorWorkflow: {
				id: 'editorWorkflow',
				text: 'Editor Review Queue',
				path: 'workflow/editor',
				icon: 'Edit',
			},
			publisherWorkflow: {
				id: 'publisherWorkflow',
				text: 'Publisher Queue',
				path: 'workflow/publisher',
				icon: 'Publish',
			},
			adminWorkflowDashboard: {
				id: 'adminWorkflowDashboard',
				text: 'Workflow Admin',
				path: 'workflow/admin/dashboard',
				icon: 'AdminPanelSettings',
			},
			stateEditorWorkflow: {
				id: 'stateEditorWorkflow',
				text: 'State Editor Queue',
				path: 'workflow/state-editor',
				icon: 'Map',
			},
			languageContentQueue: {
				id: 'languageContentQueue',
				text: 'Language Content Queue',
				path: 'admin/content-distribution',
				icon: 'Translate',
			},
		},
	},
	accessControlManagement: {
		id: 'accessControlManagement',
		text: 'Access Control',
		path: '#',
		icon: 'Security',
		notification: false,
		subMenu: {
			permissionManagement: {
				id: 'permissionManagement',
				text: 'Permission Management',
				path: 'admin/access-control/permissions',
				icon: 'Key',
			},
			rolePermissionMatrix: {
				id: 'rolePermissionMatrix',
				text: 'Role Permissions',
				path: 'admin/access-control/roles',
				icon: 'GridOn',
			},
			userAccessControl: {
				id: 'userAccessControl',
				text: 'User Access',
				path: 'admin/access-control/users',
				icon: 'ManageAccounts',
			},
			auditLogs: {
				id: 'auditLogs',
				text: 'Audit Logs',
				path: 'admin/access-control/audit',
				icon: 'History',
			},
		},
	},
	readerPlatform: {
		id: 'readerPlatform',
		text: 'Reader Platform',
		path: '#',
		icon: 'PeopleAlt',
		notification: false,
		subMenu: {
			readerManagement: {
				id: 'readerManagement',
				text: 'Readers',
				path: 'admin/readers',
				icon: 'PersonSearch',
			},
		},
	},
	reporterPlatform: {
		id: 'reporterPlatform',
		text: 'Reporter Platform',
		path: '#',
		icon: 'Badge',
		notification: false,
		subMenu: {
			reporterManagement: {
				id: 'reporterManagement',
				text: 'Reporters',
				path: 'admin/reporters',
				icon: 'PersonSearch',
			},
			redemptionManagement: {
				id: 'redemptionManagement',
				text: 'Redemptions',
				path: 'admin/redemptions',
				icon: 'Payments',
			},
			articleReport: {
				id: 'articleReport',
				text: 'Article Report',
				path: 'admin/article-report',
				icon: 'Assessment',
			},
			coinRules: {
				id: 'coinRules',
				text: 'Coin Rules',
				path: 'admin/coin-rules',
				icon: 'MonetizationOn',
			},
			stateCoverage: {
				id: 'stateCoverage',
				text: 'State Coverage',
				path: 'admin/state-coverage',
				icon: 'Map',
			},
		},
	},
	audioSettings: {
		id: 'audioSettings',
		text: 'Audio Settings',
		path: '#',
		icon: 'RecordVoiceOver',
		notification: false,
		subMenu: {
			voiceConfiguration: {
				id: 'voiceConfiguration',
				text: 'Voice Configuration',
				path: 'admin/audio-settings/voices',
				icon: 'RecordVoiceOver',
			},
			backgroundMusic: {
				id: 'backgroundMusic',
				text: 'Background Music',
				path: 'admin/audio-settings/bgm',
				icon: 'LibraryMusic',
			},
		},
	},
	contentDistribution: {
		id: 'contentDistribution',
		text: 'Content Distribution',
		path: '#',
		icon: 'Language',
		notification: false,
		subMenu: {
			coverageDashboard: {
				id: 'coverageDashboard',
				text: 'Coverage Dashboard',
				path: 'admin/content-distribution',
				icon: 'GridView',
			},
		},
	},
	aiContentTools: {
		id: 'aiContentTools',
		text: 'AI Content Tools',
		path: '#',
		icon: 'AutoAwesome',
		notification: false,
		subMenu: {
			journalistGenerator: {
				id: 'journalistGenerator',
				text: 'Journalist Generator',
				path: 'admin/ai/journalist',
				icon: 'Edit',
			},
		},
	},
	stateConfiguration: {
		id: 'stateConfiguration',
		text: 'State Configuration',
		path: '#',
		icon: 'Tune',
		notification: false,
		subMenu: {
			stateWorkflowConfig: {
				id: 'stateWorkflowConfig',
				text: 'Workflow Rules',
				path: 'admin/state-configuration/workflow-config',
				icon: 'AccountTree',
			},
			userStateRoles: {
				id: 'userStateRoles',
				text: 'State Role Assignments',
				path: 'admin/state-configuration/user-state-roles',
				icon: 'ManageAccounts',
			},
			stateLanguageConfig: {
				id: 'stateLanguageConfig',
				text: 'Language Configuration',
				path: 'admin/state-configuration/language-config',
				icon: 'Language',
			},
		},
	},
	newsIntelligence: {
		id: 'newsIntelligence',
		text: 'News Intelligence',
		path: '#',
		icon: 'Rss',
		notification: false,
		subMenu: {
			newsDigest: {
				id: 'newsDigest',
				text: 'News Digest',
				path: 'admin/news-intelligence/digest',
				icon: 'FeedOutlined',
			},
			feedSources: {
				id: 'feedSources',
				text: 'Feed Sources',
				path: 'admin/news-intelligence/sources',
				icon: 'LinkOutlined',
			},
			syncHistory: {
				id: 'syncHistory',
				text: 'Sync History',
				path: 'admin/news-intelligence/sync-logs',
				icon: 'History',
			},
			youtubeDigest: {
				id: 'youtubeDigest',
				text: 'YouTube Digest',
				path: 'admin/news-intelligence/youtube/digest',
				icon: 'YouTube',
			},
			youtubeChannels: {
				id: 'youtubeChannels',
				text: 'YouTube Channels',
				path: 'admin/news-intelligence/youtube/channels',
				icon: 'VideoSettings',
			},
		},
	},
	moderation: {
		id: 'moderation',
		text: 'Moderation',
		path: '#',
		icon: 'Shield',
		notification: false,
		subMenu: {
			commentsModeration: {
				id: 'commentsModeration',
				text: 'Comments',
				path: 'moderation/comments',
				icon: 'Comment',
			},
			reportsModeration: {
				id: 'reportsModeration',
				text: 'Reports',
				path: 'moderation/reports',
				icon: 'Flag',
			},
		},
	},
};

export const demoPagesMenu = {
	auth: {
		id: 'auth',
		text: 'Auth Pages',
		icon: 'Extension',
	},
	logout: {
		id: 'logout',
		text: 'Logout',
		path: '/logout',
		icon: 'Logout',
	},
};

export const pageLayoutTypesPagesMenu = {
	layoutTypes: {
		id: 'layoutTypes',
		text: 'Page Layout Types',
	},
	blank: {
		id: 'blank',
		text: 'Blank',
		path: 'page-layouts/blank',
		icon: 'check_box_outline_blank ',
	},
	pageLayout: {
		id: 'pageLayout',
		text: 'Page Layout',
		path: 'page-layouts',
		icon: 'BackupTable',
		subMenu: {
			headerAndSubheader: {
				id: 'headerAndSubheader',
				text: 'Header & Subheader',
				path: 'page-layouts/header-and-subheader',
				icon: 'ViewAgenda',
			},
			onlyHeader: {
				id: 'onlyHeader',
				text: 'Only Header',
				path: 'page-layouts/only-header',
				icon: 'ViewStream',
			},
			onlySubheader: {
				id: 'onlySubheader',
				text: 'Only Subheader',
				path: 'page-layouts/only-subheader',
				icon: 'ViewStream',
			},
			onlyContent: {
				id: 'onlyContent',
				text: 'Only Content',
				path: 'page-layouts/only-content',
				icon: 'WebAsset',
			},
		},
	},
	asideTypes: {
		id: 'asideTypes',
		text: 'Aside Types',
		path: 'aside-types',
		icon: 'Vertical Split',
		subMenu: {
			defaultAside: {
				id: 'defaultAside',
				text: 'Default Aside',
				path: 'aside-types/default-aside',
				icon: 'ViewQuilt',
			},
			minimizeAside: {
				id: 'minimizeAside',
				text: 'Minimize Aside',
				path: 'aside-types/minimize-aside',
				icon: 'View Compact',
			},
		},
	},
};

export const gettingStartedPagesMenu = {
	gettingStarted: {
		id: 'gettingStarted',
		text: 'Getting Started',
		path: 'getting-started',
		icon: 'Book',
		subMenu: {
			installation: {
				id: 'installation',
				text: 'Installation',
				path: 'getting-started/installation',
				icon: 'BuildCircle',
			},
			dev: {
				id: 'dev',
				text: 'Development',
				path: 'getting-started/development',
				icon: 'DirectionsRun',
			},
			folderStructure: {
				id: 'folderStructure',
				text: 'Folder Structure',
				path: 'getting-started/folder-structure',
				icon: 'SnippetFolder',
			},
			bootstrapVariables: {
				id: 'bootstrapVariables',
				text: 'Bootstrap Variables',
				path: 'getting-started/bootstrap-variables',
				icon: 'SnippetFolder',
			},
			projectStructure: {
				id: 'projectStructure',
				text: 'Project Structure',
				path: 'getting-started/project-structure',
				icon: 'SnippetFolder',
			},
		},
	},
	routes: {
		id: 'routes',
		text: 'Routes & Pages',
		path: 'routes',
		icon: 'AltRoute',
		subMenu: {
			router: {
				id: 'router',
				text: 'Router',
				path: 'routes/router',
				icon: 'Router',
			},
		},
	},
};

export const componentPagesMenu = {
	bootstrap: {
		id: 'bootstrap',
		text: 'Bootstrap',
		icon: 'Extension',
	},
	components: {
		id: 'components',
		text: 'Component',
		path: 'components',
		icon: 'Extension',
		notification: 'success',
		subMenu: {
			accordion: {
				id: 'accordion',
				text: 'Accordion',
				path: 'components/accordion',
				icon: 'ViewDay',
			},
			alert: {
				id: 'alert',
				text: 'Alert',
				path: 'components/alert',
				icon: 'Announcement',
			},
			badge: {
				id: 'badge',
				text: 'Badge',
				path: 'components/badge',
				icon: 'Vibration',
			},
			breadcrumb: {
				id: 'breadcrumb',
				text: 'Breadcrumb',
				path: 'components/breadcrumb',
				icon: 'AddRoad',
			},
			button: {
				id: 'button',
				text: 'Button',
				path: 'components/button',
				icon: 'SmartButton',
			},
			buttonGroup: {
				id: 'buttonGroup',
				text: 'Button Group',
				path: 'components/button-group',
				icon: 'Splitscreen',
			},
			card: {
				id: 'card',
				text: 'Card',
				path: 'components/card',
				icon: 'Crop32',
			},
			carousel: {
				id: 'carousel',
				text: 'Carousel',
				path: 'components/carousel',
				icon: 'RecentActors',
			},
			// Close
			collapse: {
				id: 'collapse',
				text: 'Collapse',
				path: 'components/collapse',
				icon: 'UnfoldLess',
			},
			dropdowns: {
				id: 'dropdowns',
				text: 'Dropdowns',
				path: 'components/dropdowns',
				icon: 'Inventory',
			},
			listGroup: {
				id: 'listGroup',
				text: 'List Group',
				path: 'components/list-group',
				icon: 'ListAlt',
			},
			modal: {
				id: 'modal',
				text: 'Modal',
				path: 'components/modal',
				icon: 'PictureInPicture',
			},
			navsTabs: {
				id: 'navsTabs',
				text: 'Navs & Tabs',
				path: 'components/navs-and-tabs',
				icon: 'PivotTableChart',
			},
			// Navbar
			offcanvas: {
				id: 'offcanvas',
				text: 'Offcanvas',
				path: 'components/offcanvas',
				icon: 'VerticalSplit',
			},
			pagination: {
				id: 'pagination',
				text: 'Pagination',
				path: 'components/pagination',
				icon: 'Money',
			},
			popovers: {
				id: 'popovers',
				text: 'Popovers',
				path: 'components/popovers',
				icon: 'Assistant',
			},
			progress: {
				id: 'progress',
				text: 'Progress',
				path: 'components/progress',
				icon: 'HourglassTop',
			},
			scrollspy: {
				id: 'scrollspy',
				text: 'Scrollspy',
				path: 'components/scrollspy',
				icon: 'KeyboardHide',
			},
			spinners: {
				id: 'spinners',
				text: 'Spinners',
				path: 'components/spinners',
				icon: 'RotateRight',
			},
			table: {
				id: 'table',
				text: 'Table',
				path: 'components/table',
				icon: 'TableChart',
			},
			toasts: {
				id: 'toasts',
				text: 'Toasts',
				path: 'components/toasts',
				icon: 'RotateRight',
			},
			tooltip: {
				id: 'tooltip',
				text: 'Tooltip',
				path: 'components/tooltip',
				icon: 'Assistant',
			},
		},
	},
	forms: {
		id: 'forms',
		text: 'Forms',
		path: 'forms',
		icon: 'CheckBox',
		notification: 'success',
		subMenu: {
			formGroup: {
				id: 'formGroup',
				text: 'Form Group',
				path: 'forms/form-group',
				icon: 'Source',
			},
			formControl: {
				id: 'formControl',
				text: 'Form Controls',
				path: 'forms/form-controls',
				icon: 'Create',
			},
			select: {
				id: 'select',
				text: 'Select',
				path: 'forms/select',
				icon: 'Checklist',
			},
			checksAndRadio: {
				id: 'checksAndRadio',
				text: 'Checks & Radio',
				path: 'forms/checks-and-radio',
				icon: 'CheckBox',
			},
			range: {
				id: 'range',
				text: 'Range',
				path: 'forms/range',
				icon: 'HdrStrong',
			},
			inputGroup: {
				id: 'inputGroup',
				text: 'Input Group',
				path: 'forms/input-group',
				icon: 'PowerInput',
			},
			validation: {
				id: 'validation',
				text: 'Validation',
				path: 'forms/validation',
				icon: 'VerifiedUser',
			},
			wizard: {
				id: 'wizard',
				text: 'Wizard',
				path: 'forms/wizard',
				icon: 'LinearScale',
			},
		},
	},
	content: {
		id: 'content',
		text: 'Content',
		path: 'content',
		icon: 'format_size',
		subMenu: {
			typography: {
				id: 'typography',
				text: 'Typography',
				path: 'content/typography',
				icon: 'text_fields',
			},
			images: {
				id: 'images',
				text: 'Images',
				path: 'content/images',
				icon: 'Image ',
			},
			tables: {
				id: 'tables',
				text: 'Tables',
				path: 'content/tables',
				icon: 'table_chart',
			},
			figures: {
				id: 'figures',
				text: 'Figures',
				path: 'content/figures',
				icon: 'Photo Library ',
			},
		},
	},
	utilities: {
		id: 'utilities',
		text: 'Utilities',
		path: 'utilities',
		icon: 'Support',
		subMenu: {
			api: {
				id: 'api',
				text: 'API',
				path: 'utilities/api',
				icon: 'Api',
			},
			background: {
				id: 'background',
				text: 'Background',
				path: 'utilities/background',
				icon: 'FormatColorFill',
			},
			borders: {
				id: 'borders',
				text: 'Borders',
				path: 'utilities/borders',
				icon: 'BorderStyle',
			},
			colors: {
				id: 'colors',
				text: 'Colors',
				path: 'utilities/colors',
				icon: 'InvertColors',
			},
			display: {
				id: 'display',
				text: 'Display',
				path: 'utilities/display',
				icon: 'LaptopMac',
			},
			flex: {
				id: 'flex',
				text: 'Flex',
				path: 'utilities/flex',
				icon: 'SettingsOverscan',
			},
			float: {
				id: 'float',
				text: 'Float',
				path: 'utilities/float',
				icon: 'ViewArray',
			},
			interactions: {
				id: 'interactions',
				text: 'Interactions',
				path: 'utilities/interactions',
				icon: 'Mouse',
			},
			overflow: {
				id: 'overflow',
				text: 'Overflow',
				path: 'utilities/overflow',
				icon: 'TableRows',
			},
			position: {
				id: 'position',
				text: 'Position',
				path: 'utilities/position',
				icon: 'Adjust',
			},
			shadows: {
				id: 'shadows',
				text: 'Shadows',
				path: 'utilities/shadows',
				icon: 'ContentCopy',
			},
			sizing: {
				id: 'sizing',
				text: 'Sizing',
				path: 'utilities/sizing',
				icon: 'Straighten',
			},
			spacing: {
				id: 'spacing',
				text: 'Spacing',
				path: 'utilities/spacing',
				icon: 'SpaceBar',
			},
			text: {
				id: 'text',
				text: 'Text',
				path: 'utilities/text',
				icon: 'TextFields',
			},
			verticalAlign: {
				id: 'vertical-align',
				text: 'Vertical Align',
				path: 'utilities/vertical-align',
				icon: 'VerticalAlignCenter',
			},
			visibility: {
				id: 'visibility',
				text: 'Visibility',
				path: 'utilities/visibility',
				icon: 'Visibility',
			},
		},
	},
	extra: {
		id: 'extra',
		text: 'Extra Library',
		icon: 'Extension',
		path: undefined,
	},
	icons: {
		id: 'icons',
		text: 'Icons',
		path: 'icons',
		icon: 'Grain',
		notification: 'success',
		subMenu: {
			icon: {
				id: 'icon',
				text: 'Icon',
				path: 'icons/icon',
				icon: 'Lightbulb',
			},
			material: {
				id: 'material',
				text: 'Material',
				path: 'icons/material',
				icon: 'Verified',
			},
		},
	},
	charts: {
		id: 'charts',
		text: 'Charts',
		path: 'charts',
		icon: 'AreaChart',
		notification: 'success',
		subMenu: {
			chartsUsage: {
				id: 'chartsUsage',
				text: 'General Usage',
				path: 'charts/general-usage',
				icon: 'Description',
			},
			chartsSparkline: {
				id: 'chartsSparkline',
				text: 'Sparkline',
				path: 'charts/sparkline',
				icon: 'AddChart',
			},
			chartsLine: {
				id: 'chartsLine',
				text: 'Line',
				path: 'charts/line',
				icon: 'ShowChart',
			},
			chartsArea: {
				id: 'chartsArea',
				text: 'Area',
				path: 'charts/area',
				icon: 'AreaChart',
			},
			chartsColumn: {
				id: 'chartsColumn',
				text: 'Column',
				path: 'charts/column',
				icon: 'BarChart',
			},
			chartsBar: {
				id: 'chartsBar',
				text: 'Bar',
				path: 'charts/bar',
				icon: 'StackedBarChart',
			},
			chartsMixed: {
				id: 'chartsMixed',
				text: 'Mixed',
				path: 'charts/mixed',
				icon: 'MultilineChart',
			},
			chartsTimeline: {
				id: 'chartsTimeline',
				text: 'Timeline',
				path: 'charts/timeline',
				icon: 'WaterfallChart',
			},
			chartsCandleStick: {
				id: 'chartsCandleStick',
				text: 'Candlestick',
				path: 'charts/candlestick',
				icon: 'Cake',
			},
			chartsBoxWhisker: {
				id: 'chartsBoxWhisker',
				text: 'Box Whisker',
				path: 'charts/box-whisker',
				icon: 'SportsMma',
			},
			chartsPieDonut: {
				id: 'chartsPieDonut',
				text: 'Pie & Donut',
				path: 'charts/pie-donut',
				icon: 'PieChart',
			},
			chartsRadar: {
				id: 'chartsRadar',
				text: 'Radar',
				path: 'charts/radar',
				icon: 'BrightnessLow',
			},
			chartsPolar: {
				id: 'chartsPolar',
				text: 'Polar',
				path: 'charts/polar',
				icon: 'TrackChanges',
			},
			chartsRadialBar: {
				id: 'chartsRadialBar',
				text: 'Radial Bar',
				path: 'charts/radial-bar',
				icon: 'DonutLarge',
			},
			chartsBubble: {
				id: 'chartsBubble',
				text: 'Bubble',
				path: 'charts/bubble',
				icon: 'BubbleChart',
			},
			chartsScatter: {
				id: 'chartsScatter',
				text: 'Scatter',
				path: 'charts/scatter',
				icon: 'ScatterPlot',
			},
			chartsHeatMap: {
				id: 'chartsHeatMap',
				text: 'Heat Map',
				path: 'charts/heat-map',
				icon: 'GridOn',
			},
			chartsTreeMap: {
				id: 'chartsTreeMap',
				text: 'Tree Map',
				path: 'charts/tree-map',
				icon: 'AccountTree',
			},
		},
	},
	notification: {
		id: 'notification',
		text: 'Notification',
		path: 'notifications',
		icon: 'NotificationsNone',
	},
	hooks: {
		id: 'hooks',
		text: 'Hooks',
		path: 'hooks',
		icon: 'Anchor',
	},
};

export const productsExampleMenu = {
	companyA: { id: 'companyA', text: 'Company A', path: 'grid-pages/products', subMenu: null },
	companyB: { id: 'companyB', text: 'Company B', path: '/', subMenu: null },
	companyC: { id: 'companyC', text: 'Company C', path: '/', subMenu: null },
	companyD: { id: 'companyD', text: 'Company D', path: '/', subMenu: null },
};


export const userPageMenu = {
	userData :{
		id: 'userData',
		text: 'User Details',
		path: 'user-details',
		icon: 'Person',
	}
}
